import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTretinoinGlyphSecondary from './svgs/TretinoinGlyphSecondary.js';
import SvgTretinoinGlyph from './svgs/TretinoinGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var tretinoinGlyph = (props => useIcon(SvgTretinoinGlyph, SvgTretinoinGlyphSecondary, props));

export { tretinoinGlyph as default };
